import React from 'react';
import AdminRedirect from './components/AdminRedirect';
import { Routes, Route } from 'react-router-dom';

import Home from './components/Home';
import Navbar from './components/Header/Navbar';
import Footer from './components/Footer';

import Products from './components/Products';
import About from './components/About';
import Contact from './components/Contact';

import CategoryProductsPage from './components/CategoryProductPage';
import SubcategoryProductPage from './components/SubcategoryProductPage';
import ProductDetailPage from './components/ProductDetailPage';

import CartPage from './components/CartPage';
import CheckoutPage from './components/CheckoutPage';
import OrderConfirmation from './components/OrderConfirmation';

import { CartProvider } from './context/CartContext';

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-900">
      <CartProvider>
        <Navbar />

        <main className="flex-grow">
          <Routes>
            <Route path="/admin/*" element={<AdminRedirect />} />

            {/* HOME */}
            <Route path="/" element={<Home />} />

            {/* CART & CHECKOUT */}
            <Route
              path="/cart"
              element={<CartPage />}
            />
            <Route
              path="/checkout"
              element={
                <CheckoutPage />
              }
            />
            <Route path="/payment-result" element={<OrderConfirmation />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />

            {/* PRODUCT */}
            <Route path="/product/:productSlug" element={<ProductDetailPage />} />

            {/* STATIC */}
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* ✅ SLUG-BASED CATEGORY ROUTES */}
            <Route
              path="/:mainSlug/:categorySlug"
              element={<CategoryProductsPage />}
            />

            <Route
              path="/:mainSlug/:categorySlug/:subcategorySlug"
              element={<SubcategoryProductPage />}
            />

            {/* 404 */}
            <Route
              path="*"
              element={
                <div className="flex items-center justify-center min-h-screen">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-white mb-4">404</h1>
                    <p className="text-xl text-gray-300">Page not found</p>
                    <a href="/" className="mt-6 inline-block text-blue-400 hover:text-blue-300">
                      Return to Home
                    </a>
                  </div>
                </div>
              }
            />

          </Routes>
        </main>

        <Footer />
      </CartProvider>
    </div>
  );
}

export default App;
